export default function checkDuplicateRouteNames(state) {
    var duplicates = [];
    var getRouteNames = function(location, state) {
        state.routes.forEach(function(route) {
            var _route_state_routeNames, _route_state;
            var currentLocation = location ? "".concat(location, " > ").concat(route.name) : route.name;
            (_route_state = route.state) === null || _route_state === void 0 ? void 0 : (_route_state_routeNames = _route_state.routeNames) === null || _route_state_routeNames === void 0 ? void 0 : _route_state_routeNames.forEach(function(routeName) {
                if (routeName === route.name) {
                    duplicates.push([
                        currentLocation,
                        "".concat(currentLocation, " > ").concat(route.name)
                    ]);
                }
            });
            if (route.state) {
                getRouteNames(currentLocation, route.state);
            }
        });
    };
    getRouteNames("", state);
    return duplicates;
}
